import { Image, Button} from "antd";
// models
import EscudoAlcaldiaBlanco from "../../../../assets/landing/medellin.png";
import jsPDF from 'jspdf';
import { PDF_PW, PDF_MG, PDF_CW, PDF_LABEL_W } from '../../../../utils/pdfPage';

export const Formulario = ({ jurado, juradoPostulacion } : any) => {
  const imprimir = async () => {
    const PW = PDF_PW, MG = PDF_MG, CW = PDF_CW;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const str = (v: any) => (v == null ? '' : String(v));

    // Logo
    let logoBase64 = '';
    try {
      const src = EscudoAlcaldiaBlanco as unknown as string;
      if (src.startsWith('data:')) {
        logoBase64 = src;
      } else {
        const blob = await fetch(src).then(r => r.blob());
        logoBase64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    } catch { /* logo no disponible */ }

    let y = MG;

    // Cabecera
    const HEADER_H = 22;
    pdf.setFillColor(240, 240, 240);
    pdf.rect(MG, y, CW, HEADER_H, 'F');
    if (logoBase64) {
      try {
        const fmt = logoBase64.startsWith('data:image/jpe') ? 'JPEG' : 'PNG';
        pdf.addImage(logoBase64, fmt, MG + 2, y + 2, 18, 12);
      } catch { /* logo no disponible */ }
    }
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10);
    pdf.text('SECRETARÍA DE CULTURA CIUDADANA', PW / 2, y + 9, { align: 'center' });
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8);
    pdf.text('CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA', PW / 2, y + 16, { align: 'center' });
    y += HEADER_H + 6;

    // Campos
    const LBL_W = PDF_LABEL_W;
    const VAL_X = MG + LBL_W + 4;
    const VAL_W = CW - LBL_W - 4;
    const LH = 4.5;
    const ROW_PAD = 2;
    pdf.setFontSize(9);

    const nombreCompleto = [jurado.primer_nombre, jurado.segundo_nombre, jurado.primer_apellido, jurado.segundo_apellido]
      .filter(Boolean).join(' ');

    const campos = [
      { label: 'Código', value: str(juradoPostulacion.data.radicado) },
      { label: 'Línea convocatoria', value: `Banco de Jurados SCC - ${str(juradoPostulacion.data.fecha_creacion)}` },
      { label: 'Tipo de participante', value: 'Persona Natural' },
    ];

    const renderRow = (lblLines: string[], valLines: string[]) => {
      const rowH = Math.max(lblLines.length, valLines.length) * LH + ROW_PAD * 2;
      const textY = y + ROW_PAD + LH * 0.8;
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(80, 80, 80);
      lblLines.length && pdf.text(lblLines, MG, textY);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(0, 0, 0);
      valLines.length && pdf.text(valLines, VAL_X, textY);
      y += rowH;
    };

    for (const campo of campos) {
      pdf.setFont('helvetica', 'bold');
      const lblLines = pdf.splitTextToSize(campo.label + ':', LBL_W);
      pdf.setFont('helvetica', 'normal');
      const valLines = pdf.splitTextToSize(campo.value, VAL_W);
      renderRow(lblLines, valLines);
    }

    // Separador HR
    y += 2;
    pdf.setDrawColor(180, 180, 180);
    pdf.line(MG, y, MG + CW, y);
    y += 6;

    // Participante
    const partCampos = [
      { label: 'Nombre del participante', value: nombreCompleto },
      { label: 'Documento identificación', value: str(jurado.numero_documento) },
    ];

    for (const campo of partCampos) {
      pdf.setFont('helvetica', 'bold');
      const lblLines = pdf.splitTextToSize(campo.label + ':', LBL_W);
      pdf.setFont('helvetica', 'normal');
      const valLines = pdf.splitTextToSize(campo.value, VAL_W);
      renderRow(lblLines, valLines);
    }

    pdf.save(`${str(juradoPostulacion.data.radicado)}.pdf`);
  };

  return (
    <div
      id="modal_custom"
      className="row"
      style={{
        paddingRight: "16px",
        paddingLeft: "16px",
        paddingTop: "16px",
        paddingBottom: "16px",
      }}
    >
      <div className="container-fluid border bg-light p-4">
        <div className="row">
          <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%"}} preview={false} />
          <br />
          <br />
          <span className="md-title-text text-center font-size-16px">
            <br />
            SECRETARÍA DE CULTURA CIUDADANA
          </span>
          <br />
          <span className="md-title-text text-center font-size-16px">
            CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
          </span>
        </div>
      </div>
      <div className="row">
        <br />
      </div>
      {console.log(juradoPostulacion)}
      <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div
          className="col-4 font-size-14px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Código:
        </div>
        <div className="col-6 font-size-14px font-family-Montserrat-Regular">
          {juradoPostulacion.data.radicado}
        </div>
      </div>
      <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div
          className="col-4 font-size-14px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Línea convocatoria:
        </div>
        <div className="col-6 font-size-14px font-family-Montserrat-Regular">
          Banco de Jurados SCC - {juradoPostulacion.data.fecha_creacion}
        </div>
      </div>
      <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div
          className="col-4 font-size-14px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Tipo de participante:
        </div>
        <div className="col-6 font-size-14px font-family-Montserrat-Regular">
          Persona Natural
        </div>
      </div>
      <hr />
      <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div
          className="col-4 font-size-14px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Nombre del participante:
        </div>
        <div className="col-6 font-size-14px font-family-Montserrat-Regular">
          {jurado.primer_nombre} {jurado.segundo_nombre} {jurado.primer_apellido} {jurado.segundo_apellido}
        </div>
      </div>
      <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div
          className="col-4 font-size-14px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Documento identificación:
        </div>
        <div className="col-6 font-size-14px font-family-Montserrat-Regular">
          {jurado.numero_documento}
        </div>
      </div>
      <div id="footer"></div>
      <div className="col-2 text-center">
        <Button className="form_bg_btn button-blanco-radius" onClick={imprimir}>
            Descargar
        </Button>
      </div>
    </div>
  );
};
